import React, { useState, useEffect } from 'react';
import api from '../services/api';

const fmt = n => Number(n || 0).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function Rates() {
  const [rates, setRates] = useState([]);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadRates = () => {
    api.get('/rates').then(r => { setRates(r.data); setLoading(false); });
  };

  useEffect(() => { loadRates(); }, []);

  const startEdit = () => {
    setForm(rates.map(r => ({ ...r, rate: r.rate.toString() })));
    setEditing(true);
  };

  const updateRate = (idx, val) => {
    setForm(f => f.map((r, i) => i === idx ? { ...r, rate: val } : r));
  };

  const save = async () => {
    try {
      await api.put('/rates', { rates: form.map(r => ({ id: r.id, rate: parseFloat(r.rate) })) });
      setEditing(false);
      loadRates();
    } catch (e) { alert('Error: ' + e.message); }
  };

  const grouped = {};
  const source = editing ? form : rates;
  source.forEach(r => {
    if (!grouped[r.consumer_type]) grouped[r.consumer_type] = [];
    grouped[r.consumer_type].push(r);
  });

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div>
      <div className="flex-between">
        <h1 className="page-title">Water Rates</h1>
        {!editing ? (
          <button className="btn btn-primary" onClick={startEdit}>Edit Rates</button>
        ) : (
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-success" onClick={save}>Save</button>
            <button className="btn" style={{ background: '#eee' }} onClick={() => setEditing(false)}>Cancel</button>
          </div>
        )}
      </div>

      {Object.entries(grouped).map(([type, typeRates]) => (
        <div className="card" key={type}>
          <h3 style={{ textTransform: 'capitalize' }}>{type}</h3>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Tier</th><th>Min (m³)</th><th>Max (m³)</th><th className="text-right">Rate (PHP/m³)</th></tr></thead>
              <tbody>
                {typeRates.map((r, i) => {
                  const globalIdx = source.indexOf(r);
                  return (
                    <tr key={r.id}>
                      <td>Tier {r.tier}</td>
                      <td>{r.min_cu_m}</td>
                      <td>{r.max_cu_m || '∞'}</td>
                      <td className="text-right">
                        {editing ? (
                          <input className="input" type="number" step="0.01" style={{ width: 120, textAlign: 'right' }}
                            value={form[globalIdx].rate} onChange={e => updateRate(globalIdx, e.target.value)} />
                        ) : (
                          `PHP ${fmt(r.rate)}`
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ))}

      <div className="card">
        <h3>Rate Structure</h3>
        <p style={{ color: '#666', lineHeight: 1.6 }}>
          Water rates are calculated using a tiered structure:<br />
          <strong>Tier 1</strong> (0-10 m³): Base rate - minimum charge<br />
          <strong>Tier 2</strong> (11-20 m³): Per cubic meter rate<br />
          <strong>Tier 3</strong> (21+ m³): Per cubic meter rate<br /><br />
          A <strong>PHP 50.00 meter rental</strong> is added to each bill.<br />
          A <strong>2% monthly penalty</strong> is applied on past due amounts.
        </p>
      </div>
    </div>
  );
}
